import { Link as _Link } from 'react-router-dom'
import styled from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

export const Container = styled.div`
    z-index: 2;
    position: relative;
    height: 98%;
    width: 98%;
    border-radius: 8px;
    overflow: hidden;
`

export const StyledIframe = styled.iframe`
    position: absolute;
    width: 100%;
    height: 100%;
`

export const TryLinkContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin: 10px 0;
    font-size: 1.4rem;
`

export const Link = styled.div`
    font-family: Avenir;
    font-weight: normal;
    font-size: 16px;
    color: #555555;
    text-align: center;
`

export const Url = styled.span`
    color: var(--oh-orange);
    margin: 0px 5px;
    font-family: AvenirBold;
    font-weight: 600;
    font-size: 12px;
`

export const CopyImage = styled.img`
    cursor: pointer;
    width: 30px;
    height: auto;
    margin-left: 15px;
    &:active {
        transform: translateY(2px);
    }
`

export const ModalContainer = styled.div`
    flex-direction: column;
    ${FlexCentered}
    height: 258px;
    padding: 20px 40px;
`

export const Text = styled.div`
    font-family: Avenir;
    font-weight: normal;
    font-size: 16px;
    color: #555555;
    text-align: center;
    margin-bottom: 10px;
`

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 594px;
    margin-bottom: 30px;
`

export const Tooltip = styled.div`
    visibility: ${props => (props.visibility ? `visible` : `hidden`)};
    width: 50px;
    height: 30px;
    background-color: #fff;
    color: var(--oh-orange);
    text-align: center;
    border-radius: 5px;
    font-family: Avenir;
    font-weight: normal;
    font-size: 12px;
`

export const CopyImageContainer = styled.div`
    margin-top: 5px;
`
